import Home from '../components/homepage/newHome'
import About from '../components/about/newAbout'
function HomePage() {
  return (
    <div className="Home homePage">
      <Home />
      <About />
    </div>
  );
}

export default HomePage;